import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';
import {
  FETCH_PRELOADED_CAMPAIGNS,
  GET_PRELOADED_CAMPAIGN,
  CREATE_PRELOADED_CAMPAIGN,
  UPDATE_PRELOADED_CAMPAIGN,
  DELETE_PRELOADED_CAMPAIGN,
  DISBURSE_PRELOADED_CAMPAIGN,
} from 'actions/preloadedCampaign';

function* fetchPreloadedCampaigns(action) {
  try {
    const response = yield call(API.getPreloadedCampaigns, action.payload);
    yield put({ type: FETCH_PRELOADED_CAMPAIGNS.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: FETCH_PRELOADED_CAMPAIGNS.FAIL, payload: { error: e } });
  }
}

function* getPreloadedCampaign(action) {
  try {
    const response = yield call(API.getPreloadedCampaignById, action.payload);
    yield put({ type: GET_PRELOADED_CAMPAIGN.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: GET_PRELOADED_CAMPAIGN.FAIL, payload: { error: e } });
  }
}

function* createPreloadedCampaign(action) {
  try {
    const response = yield call(API.addPreloadedCampaign, action.payload);
    yield put({ type: CREATE_PRELOADED_CAMPAIGN.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: CREATE_PRELOADED_CAMPAIGN.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* updatePreloadedCampaign(action) {
  try {
    const response = yield call(API.updatePreloadedCampaign, action.payload);
    yield put({ type: UPDATE_PRELOADED_CAMPAIGN.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: UPDATE_PRELOADED_CAMPAIGN.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* deletePreloadedCampaign(action) {
  try {
    const response = yield call(API.deletePreloadedCampaign, action.payload);
    yield put({ type: DELETE_PRELOADED_CAMPAIGN.SUCCESS, payload: action.payload });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: DELETE_PRELOADED_CAMPAIGN.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* disbursePreloadedCampaign(action) {
  try {
    const response = yield call(API.disbursePreloadedCampaign, action.payload);
    yield put({ type: DISBURSE_PRELOADED_CAMPAIGN.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: DISBURSE_PRELOADED_CAMPAIGN.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* preloadedCampaign() {
  yield takeLatest(FETCH_PRELOADED_CAMPAIGNS.REQUEST, fetchPreloadedCampaigns);
  yield takeLatest(GET_PRELOADED_CAMPAIGN.REQUEST, getPreloadedCampaign);
  yield takeLatest(CREATE_PRELOADED_CAMPAIGN.REQUEST, createPreloadedCampaign);
  yield takeLatest(UPDATE_PRELOADED_CAMPAIGN.REQUEST, updatePreloadedCampaign);
  yield takeLatest(DELETE_PRELOADED_CAMPAIGN.REQUEST, deletePreloadedCampaign);
  yield takeLatest(DISBURSE_PRELOADED_CAMPAIGN.REQUEST, disbursePreloadedCampaign);
}

export default preloadedCampaign;
